import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  selectedTemplate: string | undefined;
  handleChangeTemplate: () => void;
};

const ChangeCouncilTemplateFooter: FC<Props> = ({
  selectedTemplate,
  handleChangeTemplate,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={handleChangeTemplate}
        disabled={!selectedTemplate}
      >
        {t('Change')}
      </button>
    </Modal.Footer>
  );
};

export default ChangeCouncilTemplateFooter;
